module.exports = __webpack_public_path__ + "static/media/Timer 5.7ea0a038.png";